module.exports = __webpack_public_path__ + "img/beer_id-8.4e96aaf3.png";